import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/sc-rewards.png'


const _hoisted_1 = {
  key: 0,
  class: "wp1200 withPadding rewardsWrapper"
}
const _hoisted_2 = { class: "mainTitle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-L icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "rewardsView" }
const _hoisted_6 = { class: "mainImageReward" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "data" }
const _hoisted_10 = { class: "grayBox" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "verificationStatus" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_14 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.reward)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Rewards' })))
            }, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.reward.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.reward.image.url,
                    alt: _ctx.$t('accessibility.reward.reward_image')
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_0,
                    alt: _ctx.$t('accessibility.reward.reward_image')
                  }, null, 8, _hoisted_8))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getRewardInfo(_ctx.reward, "name")), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("rewards.amount")) + ":", 1),
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.quantity,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quantity) = $event)),
                      options: _ctx.quantityOptions,
                      optionLabel: "name",
                      optionValue: "value",
                      placeholder: "1"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("rewards.price")) + ":", 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getRewardValue()) + " " + _toDisplayString(_ctx.$t("rewards.points")), 1)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["defaultButton", { disabled: !_ctx.orderAvailable }]),
                  disabled: !_ctx.orderAvailable,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.orderReward && _ctx.orderReward(...args)))
                }, _toDisplayString(_ctx.$t("rewards.order")), 11, _hoisted_11)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.getRewardInfo(_ctx.reward, "description")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSucessApplyRewardDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showSucessApplyRewardDialog) = $event)),
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("rewards.success_order")), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t("rewards.success_order_first_part")) + " " + _toDisplayString(_ctx.loyaltyPoints) + " " + _toDisplayString(_ctx.$t("rewards.success_order_second_part")), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            class: "defaultButton",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSucessApplyRewardDialog = false)),
            style: {"justify-content":"center"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}